import React from "react";
import { BurgerMenuSvg } from "../../svgComponents/BurgerMenuSvg";

const BurgerMenuButton = ({ handleClick, burgerButRef }) => {
  return (
    <button
      ref={burgerButRef}
      onClick={handleClick}
      type={"button"}
      className="flex items-center justify-center bg-deepBlue rounded-lg w-[36px] border-[1px] border-white h-[36px] sm:w-[45px] sm:h-[45px] shadow-swapButton"
    >
      <BurgerMenuSvg />
    </button>
  );
};

export default BurgerMenuButton;
